
import { defineComponent, ref, computed } from 'vue'
import { useStore } from '@/store/index'
import { useRouter, useRoute } from 'vue-router'
import { pathMapToMenu } from '@/utils/map-menus'
export default defineComponent({
  name: 'nav-menu',
  props: {
    /* 获取main传入的展开布尔值 */
    isAsideWidth: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore()
    const route = useRoute()

    const router = useRouter()
    const userMenus = computed(() => store.state.login.userMenus)
    const activeSelect = (index: string) => {
      actNum.value = index
    }
    /* 取出标签组件名 */
    const getIcon = computed(() => {
      return function (icon: string) {
        if (icon) {
          //正则取出组件名
          icon = icon.replace(/el-icon-/, '')
          return icon
        }
      }
    })
    const menuItemClick = (item: any) => {
      router.push(item.url)
    }
    const defaultAct = pathMapToMenu(userMenus.value, route.path).id
    //默认激活菜单
    let actNum = ref(defaultAct + '')
    return {
      userMenus,
      getIcon,
      activeSelect,
      actNum,
      menuItemClick
    }
  },
  components: {}
})
